import { React, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Grid from '@mui/material/Grid';
import FirstStepRegister from './FirstStepRegistration';
import LastStepRegister from './LastStepRegistration';
import { Root, classes } from './utils';

import { registerUser } from '../../../../services/userApi';
import { verifyTokenForRootAdmin } from '../../../../services/addOrganizationApi';
import AuthenticationNewLeftGrid from '../common/AuthenticationNewLeftGrid';

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get('token');
  const [isChecked, setIsChecked] = useState(false);
  const [countryList, setCountryList] = useState({ key: '', label: '' });
  const [countryValid, setCountryValid] = useState(true);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phoneNo: '',
    password: '',
    confirmPassword: '',
    organizationName: '',
    country: '',
    is_tfa: false,
    referralCodeBy: '',
  });

  const [errors, setErrors] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phoneNo: false,
    password: false,
    confirmPassword: false,
    organizationName: false,
    referralCodeBy: false,
    country: false,
  });

  const [step, setStep] = useState(1);

  const nextStep = () => {
    setStep(step + 1);
  };

  const prevStep = () => {
    setStep(step - 1);
  };

  const submitForm = async () => {
    if (formData?.email) {
      const user = await registerUser(formData);
      if (user) {
        navigate('/login');
      }
    }
  };
  useEffect(() => {
    if (token) {
      const validate = async () => {
        const response = await verifyTokenForRootAdmin(token);

        if (response?.data?.user?.email) {
          setFormData((prevState) => ({
            ...prevState,
            email: response.data.user.email,
            organizationName: response?.data?.user?.organizationName,
            referralCodeBy: response?.data?.user?.referralCode,
          }));
        }
      };
      validate();
    }
  }, [token]);
  return (
    <Root className={classes.root}>
      <Grid container component="main" className={classes.containerMainGrid}>
        {/* this is common left grid for all authentication pages */}
        {/* <AuthenticationLeftGrid /> */}
        <AuthenticationNewLeftGrid />

        <>
          {step === 1 && (
            <FirstStepRegister
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              nextStep={nextStep}
              step={step}
              token={token}
            />
          )}
          {step === 2 && (
            <LastStepRegister
              formData={formData}
              setFormData={setFormData}
              errors={errors}
              setErrors={setErrors}
              prevStep={prevStep}
              step={step}
              submitForm={submitForm}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
              countryList={countryList}
              setCountryList={setCountryList}
              countryValid={countryValid}
              setCountryValid={setCountryValid}
              token={token}
            />
          )}
        </>
      </Grid>
    </Root>
  );
};
export default Register;
